module.exports = __webpack_public_path__ + "static/media/sunrise-right.4269013e.jpg";